module.exports = __webpack_public_path__ + "img/play.66214f85.png";